// Check what variables your EmailJS template actually expects
import emailjs from '@emailjs/browser';

export async function checkTemplateVariables(testEmail) {
  const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
  const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
  const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

  emailjs.init(publicKey);

  // Test with common EmailJS template variables
  const commonVariables = {
    // Basic contact info
    name: 'Test User',
    email: testEmail,
    subject: 'Test Subject',
    message: 'Test Message',
    
    // User variables
    user_name: 'Test User',
    user_email: testEmail,
    
    // From/To variables
    from_name: 'Skyline Backpackers',
    to_name: 'Test User',
    to_email: testEmail,
    
    // Booking specific
    booking_id: 'TEST123',
    guest_name: 'Test User',
    guest_email: testEmail,
    guest_phone: '9999999999',
    check_in: 'Aug 26, 2025',
    check_out: 'Aug 28, 2025',
    nights: '2',
    beds: '1',
    total_amount: '1258',
    payment_method: 'Online Payment',
    location: 'Sindhi Colony, Hyderabad',
    contact_phone: '+91 90327 97797',
    contact_email: 'booking@skylinebackpackers.in',
    
    // Additional common variables
    reply_to: 'booking@skylinebackpackers.in',
    company_name: 'Skyline Backpackers',
    website: 'skylinebackpackers.in'
  };

  try {
    console.log('🧪 Testing template with all possible variables:', commonVariables);
    
    const response = await emailjs.send(serviceId, templateId, commonVariables);
    
    console.log('✅ Template test successful:', response);
    return {
      success: true,
      response: response,
      variables: commonVariables
    };
    
  } catch (error) {
    console.error('❌ Template test failed:', error);
    return {
      success: false,
      error: error.message,
      variables: commonVariables
    };
  }
}
